import React from 'react';
import { Modal, Form, Input } from 'antd';
  
  const SkillDialogForm = Form.create({ name: 'form_in_modal' })(
    // eslint-disable-next-line
    class extends React.Component {
      render() {
        const { visible, onCancel, onCreate, form, data} = this.props;
        const { getFieldDecorator } = form;

        return (
          <Modal
            visible={visible}
            title="Add Skill"
            okText="Save"
            onCancel={onCancel}
            onOk={onCreate}>

            <Form layout="vertical">
              <Form.Item label="Skill">
                {getFieldDecorator('skill', {
                 initialValue: data.skill,
                  rules: [{ required: true, message: 'Please input the Skill!' }],
                })( <Input /> )}
              </Form.Item>
            </Form>

          </Modal>
        );
      }
    }
  );

  export default SkillDialogForm;
